<template>
    <v-container fluid class="pa-0">
        <v-card>
            <v-card-title primary-title>
                <v-row>
                    <v-col>Requests</v-col>
                    <v-spacer />
                    <v-col class="text-right" v-if="userCanManageSamplesConfiguration">
                        <v-btn color="primary" @click="showRequestProtocolsConfig"
                            >Configure Request Protocols</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <requests-list
                    :requests="requests"
                    :search="props.search"
                    @request-updated="reloadRequests"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { withLoadingScreen } from "@/lib/loading.js";
import { samplesAPI, SavedRequest } from "@/services/samples/samplesAPI";
import { useRouter } from "vue-router";
import { useAuth } from "@/lib/ts/auth";
import RequestsList from "@/components/SamplesV2/RequestsList.vue";

const auth = useAuth();
const userCanManageSamplesConfiguration = computed(() => {
    return auth.isAuthorized("Samples:ManageConfiguration");
});

const router = useRouter();

interface Props {
    search: string
}

const props = withDefaults(defineProps<Props>(), {
    search: "",
});

const requests = ref<SavedRequest[]>([]);

onMounted(async () => {
    await reloadRequests();
});

async function reloadRequests() {
    await withLoadingScreen(async () => {
        requests.value = await samplesAPI.fetchRequests();
    });
}

function showRequestProtocolsConfig() {
    router.push({ path: "/requestsV2/config" });
}

</script>
